<template>
  <div class="vue-monthly-picker dropdown btn btn-primary btn-sm" v-dropdown="dropdownConfig">
    <div class="dropdown-toggle">
      {{displayText}}
    </div>
    <div class="dropdown-menu">
      <div class="picker dropdown-menu-content" style="text-align: center">
        <div class="flexbox">
          <span class="prev" @click="prevYear" :class="{deactive: !canBack}"></span>
          <div>{{year}}</div>
          <span class="next" @click="nextYear" :class="{deactive: !canNext}"></span>
        </div>
        <div class="flexbox monthItem">
          <template v-for="(month, idx) in monthLabels">
            <div class="item active"
                 :class="{'selected': isCurrentSelected(year, idx)}"
                 v-if="isActive(idx)"
                 @click="selectMonth(idx)"
                 :key="idx">{{month}}
            </div>
            <div v-else
                 :class="{'selected': isCurrentSelected(year, idx)}"
                 :key="idx"
                 class="item deactive">
              {{month}}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'vuestic-month-picker',
    props: {
      value: {
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      monthLabels: {
        type: Array,
        default: function () {
          return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
        },
      },
      min: {
        default: null,
      },
      max: {
        default: null,
      },
      dateFormat: {
        type: String,
        default: 'YYYY/MM',
      },
    },
    data () {
      return {
        year: moment().format('YYYY'),
        month: moment().format('MM'),
      };
    },
    mounted () {
      this.init();
    },
    watch: {
      value: function (value) {
        this.setValue(value);
      },
    },
    computed: {
      dropdownConfig () {
        return {
          disabled: this.disabled,
        };
      },
      displayText () {
        if (this.value) {
          let valueMoment = null;
          if (typeof this.value === 'string') {
            valueMoment = moment(this.value);
          } else {
            valueMoment = this.value;
          }
          if (valueMoment && valueMoment.isValid()) {
            return valueMoment.format(this.dateFormat);
          }
        } else {
          return this.placeholder;
        }
      },
      canBack () {
        if (!this.min) return true;
        const currentVal = this.internalMomentValue.clone().startOf('year');
        return this.min.isBefore(currentVal);
      },
      canNext () {
        if (!this.max) return true;
        const currentVal = this.internalMomentValue.clone().endOf('year');
        return currentVal.isBefore(this.max);
      },
      internalMomentValue () {
        const yrMonth = this.year + '/' + this.month;
        return moment(yrMonth, 'YYYY/MM');
      },
    },
    methods: {
      init () {
        this.setValue(this.value);
      },
      prevYear () {
        if (!this.canBack) return;
        let newYear = parseInt(this.year) - 1;
        this.year = newYear.toString();
      },
      nextYear () {
        if (!this.canNext) return;
        let newYear = parseInt(this.year) + 1;
        this.year = newYear.toString();
      },
      selectMonth (idx) {
        this.month = (parseInt(idx) + 1).toString();
        this.selectPicker();
      },
      selectPicker () {
        this.$emit('input', this.internalMomentValue.clone());
        this.$emit('selected', this.internalMomentValue.clone());
      },
      setValue (value) {
        if (typeof value === 'string') {
          value = moment(value);
        }
        if (value && value.isValid()) {
          this.month = value.format('MM');
          this.year = value.format('YYYY');
        }
      },
      isActive (idx) {
        let realMonth = idx + 1;
        const yrMonth = this.year + '/' + (realMonth < 10 ? '0' + realMonth : realMonth);
        if (this.min && moment(yrMonth, 'YYYY/MM').isBefore(this.min)) {
          return false;
        }
        if (this.max && moment(yrMonth, 'YYYY/MM').isAfter(this.max)) {
          return false;
        }
        return true;
      },
      isCurrentSelected (year, monthIdx) {
        if (!this.value) {
          return false;
        }
        let checkValue = this.value;
        if (typeof this.value === 'string') {
          checkValue = moment(this.value);
        }
        if (checkValue && checkValue.isValid()) {
          const currentMonth = checkValue.format('MM');
          const currentYear = checkValue.format('YYYY');
          return Number(currentMonth) === Number(monthIdx + 1) && Number(currentYear) === Number(year);
        }
        return false;
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../sass/variables";

  .vue-monthly-picker {

    .picker {
      color : $white;

      .next,
      .prev {
        &:hover {
          cursor : pointer;
        }
      }

      .monthItem {
        .item {
          &.active {
            cursor : pointer;
            &:hover {
              background-color : $dropdown-link-hover-bg;
            }
          }
          &.selected {
            background-color : $brand-primary;
          }
        }
      }

      .flexbox {
        padding   : 0;
        display   : flex;
        flex-wrap : wrap;
        div {
          flex-grow : 1;
          padding   : 15px 0;
        }
        .item {
          flex       : 1;
          flex-basis : 25%;
        }
      }
    }

    .next,
    .prev {
      width       : 16%;
      float       : left;
      text-indent : -10000px;
      position    : relative;

      &:after {
        content           : "";
        position          : absolute;
        left              : 50%;
        top               : 50%;
        -webkit-transform : translateX(-50%) translateY(-50%);
        transform         : translateX(-50%) translateY(-50%);
        border            : 6px solid transparent;
      }
    }
    .next {
      &:hover {
        background-color : $dropdown-link-hover-bg;
      }
      &:after {
        border-left : 10px solid $white;
        margin-left : 5px;
      }
      &.deactive {
        &:hover {
          cursor : default;
        }
        &:after {
          border-left : 10px solid $gray;
        }
      }
    }

    .prev {
      &:hover {
        background-color : $dropdown-link-hover-bg;
      }
      &:after {
        border-right : 10px solid $white;
        margin-left  : -5px;
      }
      &.deactive {
        &:hover {
          cursor : default;
        }
        &:after {
          border-right : 10px solid $gray;
        }
      }
    }

    .deactive {
      color : #999999;
    }

    .selected {
      background  : #007bff;
      color       : #fff;
      text-shadow : 0 -1px 0 rgba(0, 0, 0, 0.25);
      font-weight : bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-month-picker/VuesticMonthPicker.vue